import React, { useState, useEffect } from 'react'
import Button from '../Button'
import { Container, Header, Content } from './styles'

interface Props {
  header: (string | JSX.Element)[]
  children: JSX.Element[]
  contentStyle?: any
  headerStyle?: any
  activeTab?: number
  style?: any
}

const Tabs: React.FC<Props> = ({ header, children, contentStyle, headerStyle, activeTab = 0, style = {} }) => {
  const [active, setActive] = useState(activeTab)

  useEffect(() => {
    if (activeTab !== undefined) {
      setActive(activeTab)
    }
  }, [activeTab])

  return (
    <Container
      style={{ ...{ height: '100%', overflow: 'hidden' }, ...style }}
    >
      <Header style={{ ...headerStyle }}>
        {header.map((h, i) => (
          <Button
            key={i}
            label={h}
            backgroundColor={active === i ? 'darkBlue' : 'white'}
            fontColor={active === i ? 'white' : 'darkBlue'}
            onClick={() => setActive(i)}
            style={{ height: "100%", minHeight: '47px' }}
          />
        ))}
      </Header>
      <Content style={{ ...{height: '100%', overflow: 'hidden' }, ...contentStyle }}>
        {children.map((c, i) => (
          <div
            key={i}
            style={{
              height: '100%',
              display: active === i ? '' : 'none',
            }}
          >
            {c}
          </div>
        ))}
      </Content>
    </Container>
  )
}

export default Tabs
